"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function deserializerMiddleware(options, deserializer) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, function* () {
        var _yield$next = yield next(args),
            response = _yield$next.response;

        var parsed = yield deserializer(response, options);
        return {
          response: response,
          output: parsed
        };
      });
    };
  };
}

exports.deserializerMiddleware = deserializerMiddleware;